import { setRoutes, changeRoute } from '../actions';
import { ReduxComponentInterface } from '../../../types/Global';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

interface RouterProps {
  children: React.ReactElement | React.ReactElement[];
  className?: string;
  home: string;
}

interface RouterCompleteProps extends ReduxComponentInterface, RouterProps {
  hash: string;
  path: string;
}

class Router extends React.PureComponent<RouterCompleteProps> {
  constructor(props: RouterCompleteProps) {
    super(props);
    window.addEventListener('hashchange', event => {
      const hash = event.newURL.split('#')[1];
      props.actions.changeRoute(hash);
    });
  }

  static defaultProps = {
    className: '',
  };

  componentDidMount() {
    const { actions, hash, home, path } = this.props;

    // @ts-ignore
    const children: React.ReactElement[] = Array.isArray(this.props.children)
      ? this.props.children
      : [this.props.children];
    const routes = children.map(item => item?.props?.path);

    if (routes.length === 0) {
      console.warn('Router must have at least one Route');
    }

    actions.setRoutes(routes);

    if (!hash || !routes.includes(path)) {
      window.location.hash = home;
    }
  }

  componentWillUnmount() {
    window.onhashchange = null;
  }

  render() {
    const { className, path } = this.props;

    const children = Array.isArray(this.props.children) ? this.props.children : [this.props.children];
    const component = children.filter(item => {
      // @ts-ignore
      return item.props.path === path;
    })[0];

    if (!component) {
      console.warn(`No such path ${path} was found in routes definition, returning to default route`);
      return null;
    }

    return <div className={`Edocat-Router ${className}`}>{component}</div>;
  }
}

export const mapStateToProps = (state: any, props: RouterProps) => ({
  ...state.navigation,
  children: Array.isArray(props.children) ? props.children : [props.children],
});

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: bindActionCreators({ setRoutes, changeRoute }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Router);
